<gbc-table>
  <th gbc-table-header>{{'alarm-comments-table.header-date' | translate}}</th>
  <th gbc-table-header>{{'alarm-comments-table.header-message' | translate}}</th>
  <th gbc-table-header>{{'alarm-comments-table.header-author' | translate}}</th>

  @for (comment of comments; track comment) {
    <tr gbc-table-row>
      <td gbc-table-cell>{{comment.timestampEpoch | timeWithAgo}}</td>
      <td gbc-table-cell>{{comment.comment}}</td>
      <td gbc-table-cell>{{comment.username}}</td>
    </tr>
  }
</gbc-table>
